import {useEffect, useRef, useState} from "react";
import * as React from "react";
import {ClassSelectors, ApiEvent} from "./types";
import {bffApi} from "./features/chat/bffApi";
import {chatApi} from "./features/chat/chatApi";

export const Intercom = () => {
    const userData = bffApi.endpoints.getUser.useQuery();
    const intercomInfoQuery = chatApi.endpoints.getIntercomInfo.useQuery(
        undefined,
        {skip: !userData.isSuccess}
    );
    useEffect(() => {
        if (intercomInfoQuery.isSuccess && intercomInfoQuery.data) {
            const config = {
                ...intercomInfoQuery.data,
                custom_launcher_selector: `.${ClassSelectors.intercomLauncher}`,
                hide_default_launcher: false,
            };

            (window as any).intercomConfig = config;

            if ((window as any).Intercom) {
                (window as any).Intercom("update", config);
                (window as any).Intercom("trackEvent", "ai-chat-login");
            }
        }
    }, [intercomInfoQuery.fulfilledTimeStamp]);

    return <div />;
};
